// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__Rwsvh","selected":"Chip_selected__uOohx"};